import AuthService from '@/services/AuthService';

let renewTokenTimeout = null;
const AUTH_USER_SESSION_KEY = 'vuex.session.authUser';
const LEGACY_AUTH_USER_LOCAL_KEY = 'vuex.state.authUser';

export default {
  namespaced: true,

  state: {
    authUser: {},
    authUserTask: {},
    users: [],
    isLoadingAuthUserTask: false,
  },

  getters: {
    voterUsers(state) {
      return state.users.filter((user) => user.role === 'Voter');
    },
    authUser(state) {
      return state.authUser;
    },
    authUserTask(state) {
      return state.authUserTask;
    },
    isLoadingAuthUserTask(state) {
      return state.isLoadingAuthUserTask;
    },
    isAuthenticated(state) {
      return !!state.authUser.id;
    },
  },

  actions: {
    initialize({ commit, state }) {
      if (!state.authUser || !state.authUser.token) {
        const userJson = sessionStorage.getItem(AUTH_USER_SESSION_KEY) || localStorage.getItem(LEGACY_AUTH_USER_LOCAL_KEY);
        if (userJson?.length > 0) {
          const user = JSON.parse(userJson);
          commit('setAuthUser', user);
          // one-time migration from localStorage legacy key
          localStorage.removeItem(LEGACY_AUTH_USER_LOCAL_KEY);
        }
      }
    },

    doLogin({ commit }, { username, password }) {
      return new Promise((resolve, reject) => {
        AuthService.postLogin(username, password)
          .then((user) => {
            commit('setAuthUser', user);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    doLogout({ commit }) {
      return new Promise((resolve) => {
        commit('setAuthUser', {});
        resolve();
      });
    },

    refreshToken({ commit }) {
      if (renewTokenTimeout) {
        clearTimeout(renewTokenTimeout);
      }
      renewTokenTimeout = setTimeout(() => {
        AuthService.renewToken()
          .then((user) => {
            commit('setAuthUser', user);
          })
          .catch(() => {
            commit('setAuthUser', {});
          });
      }, 3000);
    },

    getUsers({ commit, state }) {
      return new Promise((resolve, reject) => {
        if (state.users.length > 0) {
          resolve(state.users);
        } else {
          AuthService.getUsers()
            .then((users) => {
              commit('setUsers', users);
              resolve(users);
            })
            .catch((error) => {
              reject(error);
            });
        }
      });
    },

    getAuthUserTask({ commit }) {
      commit('setIsLoadingAuthUserTask', true);
      return AuthService.getMyTask()
        .then((userTask) => {
          commit('setAuthUserTask', userTask);
          return userTask;
        })
        .finally(() => {
          commit('setIsLoadingAuthUserTask', false);
        });
    },
  },

  mutations: {
    setAuthUser(state, user) {
      state.authUser = user;
      //set token in all restricted service
      AuthService.setAuthToken(user.token);
    },
    setAuthUserTask(state, userTask) {
      state.authUserTask = userTask;
    },
    setUsers(state, users) {
      state.users = users;
    },
    setIsLoadingAuthUserTask(state, value) {
      state.isLoadingAuthUserTask = !!value;
    },
  },
};
